import { Route, Routes, useParams } from "react-router-dom"
import ActivityExpensesTrackingList from "./list"
import CreateActivityExpense from "./list/create"
import EditActivityExpense from "./list/edit"
import DuplicateActivityExpense from "./list/duplicate"

const ActivityExpensesTracking: React.FC = () => (
  <Routes>
    <Route index element={<ActivityExpensesTrackingList />} />
    <Route path="create" element={<CreateActivityExpense />} />
    <Route path=":activity_expense_id">
      <Route path="edit" element={<EditActivityExpense />} />
      <Route path="duplicate" element={<DuplicateActivityExpense />} />
    </Route>
  </Routes>
)

export function useActivityExpenseId() {
  return useParams<{ activity_expense_id: string }>().activity_expense_id
}

export default ActivityExpensesTracking
